
export class CreateNegotiation {
    negotiationType!: string;
    constructor(
        public rfpId?: number,
        public rfpCode?: string,
        public companyBranchName?: string,
        public companyBranchCode?: string,
        public vendor_id?: string,
        public vendorName?: string,
        public vendorInvitedCount?: number,
        public vendorRespondedCount?: number,
        public itemId?: number,
        public itemName?: string,
        public itemPrice?: number,
        public negotiationStartDate?: string,
        public negotiationStartTime?: string,
        public negotiationEndDate?: string,
        public negotiationEndTime?: string,
        public negotiationDescription?: string,
        public createdBy?: number,
        public updatedBy?: string,
        public negotiationOutcome?: string,
        public rfpType?: string,
        public rfpItemType?: string,
        public vendorDetails?: VendorDetail[],
        public rfpCharacter?: any
    ) {
        this.rfpId = rfpId;
        this.rfpCode = rfpCode;
        this.companyBranchName = companyBranchName;
        this.companyBranchCode = companyBranchCode;
        this.vendor_id = vendor_id;
        this.vendorName = vendorName;
        this.vendorInvitedCount = vendorInvitedCount;
        this.vendorRespondedCount = vendorRespondedCount;
        this.itemId = itemId;
        this.itemName = itemName;
        this.itemPrice = itemPrice;
        this.negotiationStartDate = negotiationStartDate;
        this.negotiationStartTime = negotiationStartTime;
        this.negotiationEndDate = negotiationEndDate;
        this.negotiationEndTime = negotiationEndTime;
        this.negotiationDescription = negotiationDescription;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.negotiationOutcome = negotiationOutcome;
        this.rfpType = rfpType;
        this.vendorDetails = vendorDetails;
        this.rfpItemType = rfpItemType;
        this.rfpCharacter = rfpCharacter;
    }
}

export class VendorDetail {
    itemPrice!: number;
    itemId?: number;
    itemName?: string;
    vendor_id?: number;
    vendorName?: string;
}